import { Hero } from '../components/sections/Hero';
import { ThreeProjects } from '../components/sections/ThreeProjects';

export default function Home() {
  return (
    <>
      <Hero />
      <ThreeProjects />
    </>
  );
}
